import "./ConnectionStatus.css";
import useConnectionQuality from "../Hooks/useConnectionQuality";

const ConnectionStatus = ({ peerConnection }) => {
  const { quality, latency } = useConnectionQuality(peerConnection);

  // Map quality → number of bars (1–4)
  const bars = {
    offline: 0,
    poor: 1,
    fair: 2,
    good: 4,
    unknown: 0,
  }[quality];

  const colors = {
    offline: "#888",
    poor: "red",
    fair: "orange",
    good: "green",
    unknown: "#aaa",
  };

  const color = colors[quality];

  return (
    <div className="connection-quality">
      <div className="connection-bars">
        {[1, 2, 3, 4].map((level) => (
          <div
            key={level}
            style={{
              width: "10px",
              height: `${level * 10}px`, // increasing bar height
              borderRadius: "2px",
              backgroundColor: level <= bars ? color : "#ddd",
              transition: "background-color 0.3s",
            }}
          />
        ))}
      </div>

      <p>{latency?.toFixed(0)} ms</p>
    </div>
  );
};

export default ConnectionStatus;
